import React from 'react';
import ChangeTemplateVidoes from '../../Videos/ChangeVideosList/ChangeTemplateVidoes';

const ChangeTemplateVideos = () => {
  return (
    <React.Fragment>
      <ChangeTemplateVidoes />
    </React.Fragment>
  );
};

export default ChangeTemplateVideos;



// WEBPACK FOOTER //
// ./src/Components/Training/ChangingTarainingList/ChangeTemplateVideos.jsx